module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }